if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      //if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      //this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      super.show(opener);
      // $(".js-modal-slide:not(.slick-slider)").slick({
      //   prevArrow:
      //     '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><img src="https://cdn.shopify.com/s/files/1/0509/7816/0833/files/arrow_prev_pink.svg?v=1689163130" width="40" height="40"></button>',
      //   nextArrow:
      //     '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><img src="https://cdn.shopify.com/s/files/1/0509/7816/0833/files/arrow_next_pink.svg?v=1689163130" width="40" height="40"></button>',
      //   dots: true
      // });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
        element.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }
  });
}

class VariantFdrSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {

    this.updateOptions();
    this.updateMasterId();
       
    this.removeErrorMessage();
          this.updateMedia();
    this.updateVariantInput(event); 
    //this.outOfStock();

    if (!this.currentVariant) {
      
    } else {

      this.renderProductInfo();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
  outOfStock(){
    $('.quick-add-modal .product-form__input input[type=radio]').removeAttr('disabled');
    if(this.currentVariant.available == false){
      $('.quick-add-modal .product-form__input input[type=radio]:checked').attr('disabled', 'disabled');
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  

  updateMedia() {
    if (!this.currentVariant) return;
    if(!this.currentVariant.featured_media) return;
    const mediaId = this.currentVariant.featured_image.id;
    const mediaWrap = this.closest('.quick-add-modal__content-info').querySelector('.quick-add-modal-product--media-list');
    const mediaList = mediaWrap.querySelectorAll('li');

    mediaList.forEach((mediaCell) => {
      mediaCell.classList.remove('is-active');
      if(mediaCell.dataset.mediaId == `quick-add-modal-product__media-item-${mediaId}`){
        mediaCell.classList.add('is-active');
      }
    })
  }

  updateVariantInput(event) {
    const inputTarget = event.target;
    
    $('.quick-add-modal .product-form__input input[type=radio]').removeAttr('disabled');
    if(this.currentVariant.available == false){
      $('.quick-add-modal .product-form__input input[type=radio]:checked').attr('disabled', 'disabled');
    }
    this.currentVariant = this.getVariantData().find((variant) => {
      const productForm = this.closest('.quick-add-modal__content').querySelector('form');
      const input = productForm.querySelector('input[name="id"]');
      const vid =  this.currentVariant.id;
      console.log('vid: '+ vid); 
      $('.js-quick-next-submit').removeAttr('disabled');
      $('.js-quick-next-submit').text('SUBMIT');
      if(this.currentVariant.available == false){
        $('.js-quick-next-submit').attr('disabled', 'disabled');
        $('.js-quick-next-submit').text('SOLD OUT');
      }
      input.value = this.currentVariant.id;
      $('.quick-add-modal__content-info:visible input[name="id"]').val(vid);
      console.log('value should be: '+this.currentVariant.id+' it currently is'+ $('.quick-add-modal__content-info:visible input[name="id"]').val());
      //update price
      const curprice = this.currentVariant.price/100;
      console.log("curprice: "+curprice);
      var commaNum = numberWithCommas(curprice);
      $('.price-item.price-item--regular').text("$"+commaNum);

      inputTarget.closest('.product-form__input').querySelector('.js-form--label-value').innerText = inputTarget.value;
    });
  }

  removeErrorMessage() {
  }

  renderProductInfo() {
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-fdr-radios', VariantFdrSelects);

function numberWithCommas(number) {
    var parts = number.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}
